import BenefitListItem from './BenefitListItem';
import { BenefitsListFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import { Paragraph } from '../../components/Text';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import textBaseStyle from '../../components/Text/text-base.module.css';
import style from './benefits-list.module.css';

const BenefitsList: ContentBlock<BenefitsListFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.benefitsList;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.benefitsList}
    >
      <SectionTitle>
        {contentBlockProps.title}
      </SectionTitle>

      {!!(contentBlockProps.description ?? '').trim() && (
        <div className={style.benefitsListSubtitle}>
          <Paragraph fontSize={15}>
            {contentBlockProps.description}
          </Paragraph>
        </div>
      )}

      <ul className={style.benefitList}>
        {contentBlockProps.benefits?.map(benefit => {
          if (benefit) {
            return (
              <BenefitListItem
                benefit={benefit}
                key={benefit.title}
              />
            );
          }
        })}
      </ul>

      {!!contentBlockProps.disclaimers?.length && (
        <div className={style.disclaimers}>
          {contentBlockProps.disclaimers.map(disclaimer => {
            if (disclaimer) {
              return (
                <Paragraph
                  className={textBaseStyle.fontSize12}
                  key={disclaimer.text}
                >
                  {disclaimer.text}
                </Paragraph>
              );
            }
          })}
        </div>
      )}

      {contentBlockProps.image && (
        <AppImage
          fallbackHeight={440}
          fallbackWidth={440}
          image={contentBlockProps.image}
        />
      )}
    </Section>
  );
};

export default BenefitsList;
